import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checked", "id", "label", "disabled", "showLabel", "description"];
import { forwardRef } from 'react';
import { clsx } from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line react/display-name
export var Switch = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
    id = _ref.id,
    label = _ref.label,
    disabled = _ref.disabled,
    showLabel = _ref.showLabel,
    description = _ref.description,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("label", {
    htmlFor: id,
    className: "tw-flex tw-items-start tw-cursor-pointer",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        className: "tw-relative",
        children: [/*#__PURE__*/_jsx("input", _objectSpread({
          type: "checkbox",
          "aria-label": label,
          id: id,
          className: 'tw-sr-only',
          ref: ref,
          checked: checked,
          disabled: disabled
        }, rest)), /*#__PURE__*/_jsx("div", {
          className: clsx('tw-block tw-w-4.8 tw-h-2.4 tw-rounded-1.2', {
            'tw-bg-neutral-light-500': !checked || disabled,
            'tw-bg-primary-light-400 dark:tw-bg-secondary-light-500': checked && !disabled
          })
        }), /*#__PURE__*/_jsx("div", {
          className: clsx('tw-absolute tw-left-[2px] tw-top-[2px] tw-bottom-[2px] tw-bg-neutral-light-100 tw-w-2 tw-h-2 tw-rounded-full tw-transition', {
            'tw-translate-x-2.4': checked
          })
        })]
      })
    }), showLabel ? /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-flex-col tw-pl-1.6",
      children: [/*#__PURE__*/_jsx("span", {
        className: "tw-font-subtitle5 tw-inline-block tw-pb-0.4 dark:tw-text-neutral-light-100",
        children: label
      }), description ? /*#__PURE__*/_jsx("p", {
        className: "tw-font-body5 tw-w-24 dark:tw-text-neutral-dark-500",
        children: description
      }) : null]
    }) : null]
  });
});
export default Switch;